import {Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {UserAdminDialogComponent} from "./user-admin-dialog/user-admin-dialog.component";
import {UserAdminService} from "./user-admin.service";
import {Router} from "@angular/router";
import {User} from "../../auth/auth.model";
import {UsersApiService} from "../../api/users-api.service";
import { MessageService } from "src/app/utils/message/message.service";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.scss']
})
export class UserAdminComponent implements OnInit {

  items: MatTableDataSource<User>;
  originalItems: User[];
  filteredItems: User[];
  customerNumberSearch: string = '';

  displayedColumns: string[] = ['username', 'fullName', 'role', 'actions'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) userPaginator: MatPaginator;

  constructor(
    private userAdminService: UserAdminService,
    private usersApi: UsersApiService,
    public dialog: MatDialog,
    private router: Router,
    private message: MessageService,
    private languagePickerService: LanguagePickerService,
  ) {
  }

  ngOnInit(): void {
    this.fetchUsers();
  }

  private fetchUsers() {
    this.usersApi.search({
      "count": 5000,
      "query": {},
      "startIndex": 0
    }).subscribe(response => {
      this.originalItems = this.filteredItems = response.result;
      this.items = new MatTableDataSource(this.originalItems);
      if (this.items != undefined) {
        this.items.sort = this.sort;
        this.items.paginator = this.userPaginator;
      }
    });
  }

  saveUpdateUser(user: User) {
    this.userAdminService.saveUpdate(user).subscribe(response => {
      if (response.success) {
        this.message.info("admin.users.saveSuccess");
        this.fetchUsers();
      } else {
        this.message.error(response.httpError.message);
      }
    });
  }

  deleteUser(row: User): void {
    this.userAdminService.delete(row).subscribe(response => {
      if (response.success) {
        this.message.info("admin.users.deleteSuccess");
        this.fetchUsers();
      } else {
        this.message.error(response.httpError.message);
      }
    });
  }

  openNewUserDialog(): void {
    const dialogRef = this.dialog.open(UserAdminDialogComponent, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateUser(result.data);
      }
    });
  }

  openEditUserDialog(item: User): void {
    const dialogRef = this.dialog.open(UserAdminDialogComponent, {
      width: '300px',
      data: {item: item}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.saveUpdateUser(result.data);
      }
    });
  }

  search() {
    if (this.customerNumberSearch === '') {
      this.filteredItems = this.originalItems;
    } else {
      this.filteredItems = this.originalItems.filter(item => item.account.customerNumber === this.customerNumberSearch);
    }
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  private reInitTableSortPaginator() {
    this.items.sort = this.sort;
    this.items.paginator = this.userPaginator;
  }

  goBack() {
    this.router.navigate(['/admin']);
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }
}
